import DetailsTitle from "components/common/detailsPage/DetailsTitle";
import InfoItem from "components/common/detailsPage/InfoItem";
import DetailsShimmer from "components/common/shimmer/DetailsShimmer";
import { StatusBadge } from "components/common/StatusBadge";
import { usePermission } from "hooks/usePermission";
import { useQueryParam } from "hooks/useQueryParam";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getBranchCameraDetails } from "store/slices/branchCameraSlice";

function BranchCameraDetails() {
  const { t } = useTranslation();
  const { loading, itemDetails: cameraDetails } = useSelector(
    (state) => state.BranchCamera,
  );

  const dispatch = useDispatch();
  const branchId = useQueryParam("branchId");
  const id = useQueryParam("id");
  const { canAction } = usePermission();
  const { canView } = canAction("developer_settings");

  useEffect(() => {
    if (branchId && id && canView) {
      dispatch(getBranchCameraDetails({ branchId, id }));
    }
  }, [branchId, id, dispatch, canView]);

  const cameraFields = [
    {
      label: t("Id"),
      value: cameraDetails?._id || "-",
      col: { lg: 6 },
    },
    {
      label: t("Name"),
      value: cameraDetails?.name || "-",
      col: { lg: 6 },
    },
    { isSpacer: true },
    {
      label: t("Camera Id"),
      value: cameraDetails?.cameraId || "-",
      col: { lg: 6 },
    },
    {
      label: t("Role"),
      value: cameraDetails?.role || "-",
      col: { lg: 6 },
    },
    { isSpacer: true },
    {
      label: t("Status"),
      render: <StatusBadge status={cameraDetails?.status} t={t} />,
      col: { lg: 6 },
    },
  ];

  const shimmerLayout = [
    {
      col: 8,
      blocks: [
        { rows: 4, cols: 2 },
        { rows: 1, cols: 1 },
      ],
    },
  ];

  if (loading) {
    return (
      <div className="page-content">
        <DetailsTitle title={t("Camera Details")} />
        <DetailsShimmer layout={shimmerLayout} />
      </div>
    );
  }

  return (
    <div className="page-content common_details_page branch_details">
      <DetailsTitle title={t("Camera Details")} />
      <Row>
        <Col lg={8} className="ps-0">
          <div className="common_card" style={{ height: "calc(100% - 20px)" }}>
            <Row>
              <Col lg={12} className="mb-3">
                <h2 className="title_20">{t("Basic Details")}</h2>
              </Col>

              {cameraFields.map((item, index) => {
                if (item.isSpacer) {
                  return <div key={index} className="mt-4 w-100" />;
                }

                return (
                  <InfoItem
                    key={index}
                    label={item.label}
                    value={item.value}
                    col={item.col}
                  >
                    {item.render}
                  </InfoItem>
                );
              })}
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default BranchCameraDetails;
